import { ReactNode } from 'react';
import { Pressable } from 'react-native';
import { BodyText } from '@/common/components/BodyText/BodyText';
import { Label } from '@/common/components/Label/Label';
import { Stack } from '@/common/components/Stack/Stack';
import { Indicator, Item } from '@rn-primitives/radio-group';
import { styles } from './RadioButtonBase.styles';

export const RadioButtonBase = ({
  label,
  description,
  className,
  value,
  checked,
  disabled,
  onPress,
  children,
}: IRadioButtonBaseProps) => {
  const showContent = Boolean(description || children);
  return (
    <Pressable
      onPress={() => onPress?.(value)}
      disabled={disabled}
      className={styles.root}
    >
      <Stack gap="xs" align="start" className={styles.host({ className })}>
        <Stack gap="sm" align="center" horizontal>
          <Item
            value={value}
            className={styles.box({ checked, disabled })}
            disabled={disabled}
          >
            <Indicator className={styles.innerBox} />
          </Item>
          {label && (
            <Label bold color={disabled ? 'neutral20' : 'neutral30'}>
              {label}
            </Label>
          )}
        </Stack>
        {showContent && (
          <Stack gap="xs" align="start" className={styles.content}>
            {description && (
              <BodyText size="sm" color="neutral20">
                {description}
              </BodyText>
            )}
            {children}
          </Stack>
        )}
      </Stack>
    </Pressable>
  );
};

export interface IRadioButtonBaseProps<T extends string = string> {
  label?: ReactNode;
  description?: ReactNode;
  checked?: boolean;
  value: T;
  className?: string;
  disabled?: boolean;
  onPress?: (value: T) => void;
  children?: ReactNode;
}
